<template>
<form>
  <v-container fluid grid-list-lg >
    <v-card>
      <v-toolbar >
        <v-icon>contact_phone</v-icon>
        <v-toolbar-title class="font-weight-light">&nbsp;Asignación a Gestores</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn text icon color="red" v-on="on" @click="setStatusTareaFrecuente(action)">
              <v-icon v-if="action.esFrecuente">favorite</v-icon>
              <v-icon v-else>favorite_border</v-icon>
            </v-btn>
          </template>
          <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>  
          <span v-else>Agregar a Tareas Frecuentes</span>  
        </v-tooltip>
      </v-toolbar>

      <div class="text-xs-center">
        <v-progress-linear v-show="loadingProgress" indeterminate></v-progress-linear>      
      </div>

  <v-card-text>
      <v-tabs
        v-model="currentTab">
        <v-tab>
          <v-icon>search</v-icon>
          Selección de casos
        </v-tab>
        <v-tab>
          <v-icon>assignment</v-icon>
          Resultado y Asignación
        </v-tab>
        
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-row dense>
                  <v-col cols="3">
                      <v-autocomplete v-model="filtro.empresaId" :items="listEmpresas"
                          item-text="nombre" item-value="id" label="Empresa:" placeholder="Seleccione una"></v-autocomplete>
                  </v-col>
                  
                  <v-col cols="3">
                    <v-autocomplete v-model="filtro.sucursalId" :items="sucursales"
                      item-text="nombre" item-value="id" label="Solicitudes de la Sucursal:" placeholder="Seleccione una" :menu-props="{minWidth:'400'}"></v-autocomplete>
                  </v-col>

                  <v-col cols="3">
                      <v-autocomplete v-model="filtro.canalVentaId" :items="canalesVenta"
                          item-text="nombre" item-value="id" label="Originadas en:" placeholder="Seleccione un Canal de Venta"></v-autocomplete>
                  </v-col>

                  <v-col cols="3">
                    <v-select
                        label='Origen:'
                        v-model="filtro.tipoCanalVentaId"
                        :items="tiposCanalVenta"
                        item-text="descripcion"
                        item-value="id"
                    ></v-select>
                  </v-col>

                  <v-col cols="3">
                    <v-autocomplete v-model="filtro.productoId" :items="listProductos"
                          item-text="descripcion" item-value="id" label="Productos:"></v-autocomplete>
                  </v-col>

                  <v-col cols="3">
                      <v-select
                          :items="listPlanes"
                          v-model="filtro.planes"
                          item-text="nombre"
                          item-value="id"
                          label="Planes"
                          multiple>
                          <!-- ABAJO esto es para agregar la opción de select all -->
                        <template v-slot:prepend-item>
                          <v-list-item
                            ripple
                            @click="togglePlanes"
                          >
                            <v-list-item-action>
                              <v-icon :color="filtro.planes.length > 0 ? 'indigo darken-4' : ''">{{ iconPlanes }}</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title>Marcar todos</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider class="mt-2"></v-divider>
                        </template>
                        <!-- ARRIBA esto es para agregar la opción de select all -->
                        <template v-slot:selection="{ item, index }">
                          
                            <span v-if="index === 0">{{ item.nombre }}</span>
                          
                          <span
                            v-if="index === 1"
                            class="grey--text caption"
                          >&nbsp;(+ {{ filtro.planes.length - 1 }} planes más)</span>
                        </template>
                      </v-select>
                  </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="3">
                    <v-radio-group v-model="filtro.radioFiltroMora" column>
                        <v-radio value="FiltrarVectorAtraso" label="Con Vector Atraso"></v-radio>
                    </v-radio-group>
                </v-col>
                <v-col cols ="1">
                    <v-text-field v-if="filtro.radioFiltroMora == 'FiltrarVectorAtraso'" v-model="filtro.vectorAtrasoDesde" label="Desde"></v-text-field>
                </v-col>
                <v-col cols ="1">
                    <v-text-field v-if="filtro.radioFiltroMora == 'FiltrarVectorAtraso'" v-model="filtro.vectorAtrasoHasta" label="Hasta"></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="3">
                    <v-radio-group v-model="filtro.radioFiltroMora" column>
                        <v-radio value="FiltrarInicioMora" label="Con Inicio Mora"></v-radio>
                    </v-radio-group>
                </v-col>

                <v-col cols="5">
                    <app-fecha-desdehasta v-if="filtro.radioFiltroMora == 'FiltrarInicioMora'" 
                                            v-on:desde-changed="filtro.inicioMoraDesde = $event"
                                            v-on:hasta-changed="filtro.inicioMoraHasta = $event">
                    </app-fecha-desdehasta>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols ="3">
                    <v-checkbox v-model="filtro.filtrarFechaUltimoPago" label="Filtrar Fecha Último Pago"></v-checkbox>    
                </v-col>

                <v-col cols = "3">
                  <v-layout>
                        <v-text-field v-if="filtro.filtrarFechaUltimoPago" v-model="filtro.fechaUltimoPagoHasta" label="Anterior a:" type="date" prepend-icon="event"
                            ></v-text-field>
                  </v-layout>
                </v-col>

                <v-col cols ="3">
                    <v-checkbox v-model="filtro.filtrarDeudaEntre" label="Filtrar por Rango Deuda"></v-checkbox>    
                </v-col>

                <v-col cols ="1">
                    <v-text-field v-if="filtro.filtrarDeudaEntre" v-model="filtro.deudaDesde" label="Desde"></v-text-field>
                </v-col>

                <v-col cols ="1">
                    <v-text-field v-if="filtro.filtrarDeudaEntre" v-model="filtro.deudaHasta" label="Hasta"></v-text-field>
                </v-col>
              </v-row>
                
              <v-row dense>
                <v-col cols ="3">
                    <v-checkbox v-model="filtro.excluirAcuerdosAlDia" label="Excluir Casos con Acuerdos al Día"></v-checkbox>    
                </v-col>
                <v-col cols ="3">
                    <v-checkbox v-model="filtro.excluirPromesasPagoNoVencidas" label="Excluir Promesas de Pago No Vencidas"></v-checkbox>    
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols ="3">
                    <v-checkbox v-model="filtrarPorCuotaEspecifica" label="Filtrar Cuota Puntual"></v-checkbox>    
                </v-col>
                <v-col cols ="1" v-if="filtrarPorCuotaEspecifica">
                  <v-text-field  v-model="filtro.soloCuotaEspecifica" label="Nº de Cuota"></v-text-field>
                </v-col>
                <v-col cols ="3">
                    <v-checkbox v-model="filtrarPorUltimasCuotas" label="Filtrar Últimas Cuotas"></v-checkbox>    
                </v-col>
                <v-col cols ="1" v-if="filtrarPorUltimasCuotas">
                  <v-text-field  v-model="filtro.soloUltimasCuotas" label="Últimas x Cuotas"></v-text-field>
                </v-col>

              </v-row>

              <v-row dense>
                <v-col cols="6">
                     <v-radio-group v-model="filtro.categoriaPlanes" :mandatory="true" row>
                            <v-radio value="0">
                                <div slot="label">Indistinto</div>
                            </v-radio>
                            <v-radio value="1">
                                <div slot="label">Barrido</div>
                            </v-radio>
                            <v-radio value="2">
                                <div slot="label">Camara</div>
                            </v-radio>
                            <v-radio value="3">
                                <div slot="label">PV</div>
                            </v-radio>
                            <v-radio value="4">
                                <div slot="label">Codigo</div>
                            </v-radio>
                        </v-radio-group>
                </v-col>    
                </v-row>

              <v-row dense>
                <v-col cols="3">
                    <v-radio-group v-model="filtro.situacionAsignacion" column>
                        <v-radio value="0" label="Traer Asignados y Sin Asignar"></v-radio>
                        <v-radio value="-1" label="Traer Sólo Casos NO Asignados"></v-radio>
                        <v-radio value="1" label="Traer Sólo Casos Asignados a"></v-radio>
                    </v-radio-group>
                </v-col>
              </v-row>
                  
              <v-row>
                <v-col cols="3">
                      <v-autocomplete v-if="filtro.situacionAsignacion == '1'" v-model="filtro.asignadoA" :items="listGestoresConTodos"
                          item-text="login" item-value="login" label="Gestor:" placeholder="Seleccione uno"></v-autocomplete>
                  </v-col>
                  <v-col cols="5">
                    <app-fecha-desdehasta v-if="filtro.situacionAsignacion == '1'"
                                            v-on:desde-changed="filtro.fechaAsignacionDesde = $event"
                                            v-on:hasta-changed="filtro.fechaAsignacionHasta = $event">
                    </app-fecha-desdehasta>
                  </v-col>
              </v-row>

              <v-expansion-panels multiple popout accordion>
                <v-expansion-panel>
                    <v-expansion-panel-header v-slot="{  }">
                        <v-row>
                            <v-col>Importar casos desde Archivo Excel</v-col>
                        </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col>
                          <v-alert color="warning" dark dense>
                            Al importar casos de un archivo, solo se tendrá en cuenta el filtro de Empresa. 
                            El archivo debe tener formato Excel, con sólo una columna (A) con el Número de Crédito (y con encabezado 'Credito') 
                          </v-alert>
                        </v-col>
                      </v-row>
                        <v-row align="center">
                          <v-col>
                            <v-file-input  
                                v-model="archivoFiltroOperaciones"
                                placeholder="Seleccione el archivo Excel"
                                label="Archivo Filtro"
                                prepend-icon="mdi-paperclip">
                            </v-file-input>
                          </v-col>
                          <v-col>
                            <v-btn @click="traerListaOperacionesDeExcel()">
                              Cargar Archivo
                            </v-btn>
                          </v-col>
                          <v-spacer></v-spacer>
                          <v-col v-if="archivoFiltroOperaciones != null">
                            <v-chip v-if="operacionesFiltro.id == ''" label color="warning">
                              Presione Cargar Archivo para procesarlo
                            </v-chip>
                            
                            <template v-else>
                              <v-chip  small label color="green" dark >
                                Hay {{operacionesFiltro.cantidad }} Créditos en el Archivo
                              </v-chip>
                              <v-chip  label small color="red" dark v-if="totalItems > 0 && (operacionesFiltro.cantidad - totalItems) > 0">
                                Hay {{operacionesFiltro.cantidad - totalItems  }} Créditos no encontrados
                              </v-chip>
                              
                            </template>
                          </v-col>
                          
                        </v-row>
                        <v-row v-if="operacionesFiltro.cantidad > 0">
          
                          <v-spacer></v-spacer>
                          <v-btn color="success"  @click="importarExcel()">Buscar Casos del Archivo</v-btn>
                        </v-row>
                    </v-expansion-panel-content>
                </v-expansion-panel>

              </v-expansion-panels>
            </v-card-text>
            <v-card-actions>
              <v-btn color="success" @click="getItems()">Realizar Búsqueda</v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>

        <!-- resultado y asignación -->
        <v-tab-item>
          <v-card flat>
              <v-data-table dense
                  :headers="headers" 
                  :items="records"
                  v-model="selectedCasos"
                  :loading="loading"                    
                  :show-select="records.length>0"
                  item-key="personaId"             
                >
                <template v-slot:no-data>
                  <v-alert v-if="!records.length>0" :value="true" color="grey" icon="info">
                    No se encontraron datos
                  </v-alert>
                </template>
              
                <template v-slot:header.data-table-select="{ on, props }">
                    <v-checkbox @change="selectAllChanged" color="purple" v-bind="props" v-on="on"></v-checkbox>
                </template>

                <template v-slot:item="{ item, isSelected, select }">
                    <tr>
                      <td><v-simple-checkbox class="caption" color="green" :value="isSelected" @input="select($event)"></v-simple-checkbox></td>
                      <td  >
                        <v-speed-dial direction="right" :open-on-hover='true' >
                          <template v-slot:activator >
                            <v-btn slot="activator" color="orange" fab text small>
                              <v-icon color="orange" >touch_app</v-icon>                                
                            </v-btn>
                          </template>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn fab dark small color="error" v-on="on" @click="verLegajo(item)">
                                <v-icon>person_pin</v-icon>
                              </v-btn>
                            </template>
                            <span>Legajo</span>
                          </v-tooltip>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn fab dark small color="purple" v-on="on" @click="verCreditos(item)">
                                <v-icon>playlist_add_check</v-icon>
                              </v-btn>
                            </template>
                            <span>Créditos</span>
                          </v-tooltip>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn fab dark small color="indigo" v-on="on">
                                <v-icon>history</v-icon>
                              </v-btn>
                            </template>
                            <span>Contactos</span>
                          </v-tooltip>
                        </v-speed-dial>
                      </td>

                      <td class="text-xs-left caption">{{ item.canalVentaNombre }}</td>
                      <td class="text-xs-left caption">{{ item.nombreCliente }}</td>
                      <td class="text-xs-left caption">{{ item.documento }}</td>
                      <td class="text-xs-left caption">{{ item.numeroCredito }}</td>
                      <td class="text-xs-left caption">{{ item.deuda | currency }}</td>
                      <td class="text-xs-left caption">{{ item.fechaCaida | dateParse() | dateFormat('DD-MM-YYYY')}}</td>
                      <td class="text-xs-left caption">{{ item.gestor  }}</td>
                    </tr>
                  </template>
              </v-data-table>
            </v-card >
            <v-divider></v-divider>
            <v-card flat>
              <v-card-title>
                Asignación de Casos
              </v-card-title>
              <v-card-text>
                <v-row dense>                  
                  <v-col cols="3">
                    <v-autocomplete v-model="asignacionCommand.tipoGestionId" :items="listTiposGestion"
                          item-text="descripcion" item-value="id" label="Sector Gestión"></v-autocomplete>
                  </v-col>
                  <v-col cols="3"> 
                      <v-autocomplete v-model="asignacionCommand.motivo" :items="motivoAsignacion"
                       label="Motivo: " item-value="nombre" item-text="nombre"  placeholder="Seleccione un Motivo"
                       id="motivo" @change="selectMotivo()"></v-autocomplete>
                 </v-col>
                </v-row>
                <v-row dense>                  
                  <v-col>
                    <v-radio-group v-model="tipoGestion" row>
                          <v-radio value="telefonica" label="Asignar Acciones de Gestión Telefónica"></v-radio>
                          <v-radio value="otras" label="Asignar Otras Acciones"></v-radio>                        
                    </v-radio-group>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-radio-group v-model="asignacionCommand.modoAsignacion" row>
                        <v-radio value="AsignarTodo" label="Asignar Todo"></v-radio>
                        <v-radio value="AsignarProrrateado" label="Asignar Prorrateado"></v-radio>
                        <v-radio value="AsignarPrimeros" label="Asignar primeros casos"></v-radio>
                        <v-text-field v-if="asignacionCommand.modoAsignacion === 'AsignarPrimeros'" v-model="asignacionCommand.asignarPrimeros" label="Asignar Primeros"></v-text-field>
                        <v-radio value="Desasignar" label="Desasignar"></v-radio>
                  </v-radio-group>
                </v-row>

                <v-row dense>
                  <v-col>
                    <v-select
                          :items="listGestores"
                          v-model="asignacionCommand.gestoresId"
                          item-text="login"
                          item-value="id"
                          label="Gestor"
                          :multiple="seleccionMultipleGestores">
                    </v-select>
                  </v-col>

                  <v-col>
                    <v-autocomplete v-model="asignacionCommand.tareaId" :items="listTareasPorTipoGestion"
                          item-text="descripcion" item-value="id" label="Tareas a asignar"></v-autocomplete>
                  </v-col>

                  <v-col>
                    <v-text-field v-model="asignacionCommand.fechaInicioGestion" label="Fecha Inicio Gestión:" type="date" prepend-icon="event"></v-text-field>
                  </v-col>

                  <v-col>
                    <v-checkbox v-model="asignacionCommand.cerrarGestionesAnteriores" label="Eliminar Asignación Anterior del Gestor"></v-checkbox>    
                  </v-col>
                </v-row>

                <!-- ESTA PARTE ES PARA IMPORTAR LAS ASIGNACIONES DIRECTAMENTE (EN LA PANTALLA DE ASIGNACIÓN DE CASOS) -->
                <v-expansion-panels multiple popout accordion>
                <v-expansion-panel>
                    <v-expansion-panel-header v-slot="{  }">
                        <v-row>
                            <v-col>Asignación Masiva desde Archivo Excel</v-col>
                        </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col>
                          <v-alert color="warning" dark dense>
                            El archivo debe tener formato Excel, con sólo dos columnas (A) con el Documento de la persona (y con encabezado 'Documento') y (B) con el Usuario del Gestor a asignar (con encabezado Gestor) 
                          </v-alert>
                        </v-col>
                      </v-row>
                        <v-row align="center">
                          <v-col>
                            <v-autocomplete v-model="empresaAsignacionDirectaId" :items="listEmpresas"
                              item-text="nombre" item-value="id" label="Empresa:" placeholder="Seleccione una"></v-autocomplete>
                          </v-col>
                          <v-col>
                            <v-file-input  
                                v-model="archivoAsignacionDirecta"
                                placeholder="Seleccione el archivo Excel"
                                label="Archivo Asignaciones"
                                prepend-icon="mdi-paperclip">
                            </v-file-input>
                          </v-col>
                        
                          <v-spacer></v-spacer>
                          <v-btn color="success"  @click="asignarMasivoDesdeExcel()">Asignar Masivo desde Excel</v-btn>
                          
                        </v-row>
                    </v-expansion-panel-content>
                </v-expansion-panel>

                </v-expansion-panels>
              </v-card-text>
              <v-card-actions>
                <v-btn color="success" @click="procesarCasos()">Procesar Asignaciones</v-btn>
              </v-card-actions>
            </v-card>
        </v-tab-item>
      </v-tabs>
      </v-card-text>
    </v-card>
    <app-loading :loading="loading"></app-loading>

    <!-- Ver Legajo Cliente  -->
    <v-dialog v-model="showLegajoPersona" width="1000" >
        <legajo-persona :personaId="selectedPersonaId"> </legajo-persona>
    </v-dialog>

  </v-container>

  <template v-if="$store.state.debugModeOn && (this.currentTab === 0)" >
    Debug Info: <p></p>
    
    Filtro: {{filtro}}  <p></p>
    
  </template>
  <template v-if="$store.state.debugModeOn && (this.currentTab === 1)" >
    Debug Info: <p></p>
    
    AsignacionCommand: {{asignacionCommand}}  <p></p>
    
  </template>
</form>
</template>

<script>

import Vue from 'vue'
import { http } from '@/axios'
import { ValidationObserver, ValidationProvider} from "vee-validate";

import {
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'
import { format } from 'date-fns'
import LegajoPersona from '@/components/legajo/layout.vue'

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    'legajo-persona': LegajoPersona
  },
  data () {
    return {
      currentTab:null,
      loading: false,
      loadingProgress: false, // Lo uso para la progress bar
      editMode: true,
      headers: [ // definición de columnas
        { text: 'Ver', value: 'accion', width:80, sortable:false },
        { text: 'Canal de Venta', value: 'canalVentaNombre'},
        { text: 'Deudor', value: 'nombreCliente'},
        { text: 'Documento', value: 'documento'},
        { text: '# Créditos', value: 'numeroCredito'},
        { text: 'Deuda', value: 'deuda',width: 130},
        { text: '1er Cta. Imp.', value: 'fechaCaida',width:130},
        { text: 'Asignado A', value: 'gestor'}
      ],
      records: [], // registros
      selectedCasos:[],
      filtro:{empresaId:1, sucursalId:0, productoId:0, canalVentaId:0, tipoCanalVentaId:0,planes:[], radioFiltroMora:'FiltrarVectorAtraso',vectorAtrasoDesde:0,vectorAtrasoHasta:0,inicioMoraDesde:format(new Date(),'YYYY-MM-DD'),inicioMoraHasta:format(new Date(),'YYYY-MM-DD'),
              filtrarFechaUltimoPago:false,fechaUltimoPagoHasta:format(new Date(),'YYYY-MM-DD'),filtrarDeuda:false,deudaDesde:0,deudaHasta:0,
              excluirAcuerdosAlDia:true,excluirPromesasPagoNoVencidas:true, soloCuotaEspecifica:0, soloUltimasCuotas: 0,
              situacionAsignacion:'0',fechaAsignacionDesde:format(new Date(),'YYYY-MM-DD'),fechaAsignacionHasta:format(new Date(),'YYYY-MM-DD'),categoriaPlanes:0},
      listEmpresas: [],      
      canalesVenta: [],
      listProductos: [],
      listPlanes: [],
      listTiposGestion: [],
      listGestores: [],
      listTareas:[],
      sucursales:[],
      tiposCanalVenta:[],
      motivoAsignacion:[{nombre:'Asignación Inicial'}, {nombre: 'Extra'}, {nombre: 'Rechazo'}, {nombre: 'No rotó'}],
      asignacionCommand:{personasId:[],modoAsignacion:'AsignarTodo',fechaInicioGestion:format(new Date(),'YYYY-MM-DD'),cerrarGestionesAnteriores:false, tipoGestionId: 0, motivo: ''},
      showLegajoPersona: false,
      selectedPersonaId: '',
      tipoGestion: 'telefonica',
      filtrarPorCuotaEspecifica: false,
      filtrarPorUltimasCuotas: false,
      archivoFiltroOperaciones: null,
      operacionesFiltro: {id: '', cantidad:0},
      totalItems: 0,
      empresaAsignacionDirectaId: 0,
      archivoAsignacionDirecta: null
    }
  },
  async created() {
      this.loadProductos();
      this.loadPlanes();
      this.loadCanalesVentaYEmpresas();      
      this.loadTiposGestion();
      this.loadTareas();
      this.loadSucursales();
      this.loadTiposCanalVenta();
  },
  watch:{
    seleccionMultipleGestores (val) {
        //Vue.$log.debug(val)
        //Vue.$log.debug(this.asignacionCommand.gestoresId)
        //si hay selección múltiple convierto el gestorId en array
        if (val) this.asignacionCommand.gestoresId = this.asignacionCommand.gestoresId ? [this.asignacionCommand.gestoresId] : [this.listGestores[0].id]
        else this.asignacionCommand.gestoresId = this.asignacionCommand.gestoresId[0] || this.listGestores[0].id
    },
    'filtro.empresaId'(){
      this.loadPlanes();
    },
    'asignacionCommand.tipoGestionId'(){
      this.loadGestores();
    }
  },
  computed:{
    ...mapGetters(['user', 'UiCustomUserSettings', 'DebugModeOn', 'getActionFromLink']),
    action: function(){
      return this.getActionFromLink(this.$route.path)
    },
    listGestoresConTodos:function(){
      let listGestoresConTodos = Array.from(this.listGestores);
      listGestoresConTodos.unshift({id:"00000000-0000-0000-0000-000000000000",login:'(Todos)'})
      return listGestoresConTodos;
    },
    listTareasPorTipoGestion: function(){
      if(!this.asignacionCommand.tipoGestionId) return null;

      if(this.tipoGestion == "telefonica")
        return this.listTareas.filter(t=> t.esTelefonica && !t.esEntrante && t.tipoGestionId == this.asignacionCommand.tipoGestionId)
      else
        return this.listTareas.filter(t=> !t.esTelefonica && !t.esEntrante && t.tipoGestionId == this.asignacionCommand.tipoGestionId)
    },
    /* canalesVenta: function (){
      // devuelvo los canales de venta de la empresa seleccionada
      let canalesDisponibles =this.canalesVenta.filter(i=>i.empresaId == this.model.empresaId)
      
      return canalesDisponibles
    }, */
    todosLosPlanesMarcados () {
      return this.filtro.planes.length === this.listPlanes.length
    },
    algunosPlanesMarcados () {
      return this.filtro.planes.length > 0 && !this.todosLosPlanesMarcados
    },
    iconPlanes () {
      if (this.todosLosPlanesMarcados) return 'mdi-close-box'
      if (this.algunosPlanesMarcados) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    selectedEmpresa: function(){
      if(this.filtro.empresaId && this.fltro.empresaId > 0)
        return this.listEmpresas.find(i=> i.id === this.filtro.empresaId)

      return null
    },
    selectedCanalVenta: function(){
      if(this.filtro.canalVentaId && this.filtro.canalVentaId > 0)
        return this.canalesVenta.find(i=> i.id === this.filtro.canalVentaId)

      return null
    },
    seleccionMultipleGestores: function(){
      return this.asignacionCommand.modoAsignacion === 'AsignarProrrateado';
    }
  },
  methods:{
    ...mapMutations(["setActiveTask","alertClear", "alertSuccess", "alertWarning", "alertError"]),
    ...mapActions(['setStatusTareaFrecuente']),
    togglePlanes(){
        this.$nextTick(() => {
          if (this.todosLosPlanesMarcados) {
            this.filtro.planes = []
          } else {
            this.filtro.planes = this.listPlanes.map(function(p) {return p.id;});
          }
        })
    },
    async loadProductos(){
      this.loading = true;
      try{
        var result = await http.get('productos/');        

        this.listProductos = result.list;

        this.listProductos.unshift({id:0,descripcion:'(Todos)'});
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    },
    async loadPlanes() {
        this.loading = true
        try {
            var result = await http.get('planes?empresaId=' + this.filtro.empresaId); // traigo todos
            this.listPlanes = result.list;            

            this.togglePlanes();//agrego esto para que por defecto estén todos marcados
        } catch (error) {
            // Error
            this.alertError(error)
        }
        this.loading = false
    },
    async cancelar(){
      const res = await this.$dialog.confirm({
                text: '¿Confirmar la cancelación de la carga?',
                title: 'Atención',
                persistent: true // Parece que no funciona...
              })

      if (!res) {
        return;
      }
      else{
        this.clear()
      }
    },
    async clear(){
      
    },
    async loadCanalesVentaYEmpresas() {
        this.loading = true
        try {
            var result = await http.get('canalesventa/habilitadosparausuario?usuarioId='+ this.user.id ); // traigo todas
            this.canalesVenta = result.list;

            // extraigo las empresas de los canales habilitados
            this.listEmpresas = Array.from(new Set(this.canalesVenta.map(i=>i.empresaId)))
            .map(id => {
              return {
                id: id,
                nombre: this.canalesVenta.find(s=>s.empresaId === id).empresaDescripcion
              }
            })
          
          // selecciono la empresa predefinida del usuario
          if(this.UiCustomUserSettings.empresaPredeterminadaId > 0){
            if(this.listEmpresas.find(i=> i.id === this.UiCustomUserSettings.empresaPredeterminadaId)){
              this.filtro.empresaId = this.UiCustomUserSettings.empresaPredeterminadaId
            }
          }

          // selecciono el canal de venta predefinido del usuario
          if(this.UiCustomUserSettings.canalVentaPredeterminadoId > 0){
            if(this.canalesVenta.find(i=> i.id === this.UiCustomUserSettings.canalVentaPredeterminadoId)){
              this.filtro.canalVentaId = this.UiCustomUserSettings.canalVentaPredeterminadoId
            }
          }

          this.canalesVenta.unshift({id:0,nombre:'(Todos)'});
        } catch (error) {
            // Error
            this.alertError(error)
        }
        this.loading = false
    },
    async loadGestores(){
      this.loading = true;
      try{
        var result = await http.get('usuarios/listBySectorGestion?sectorGestionId=' + this.asignacionCommand.tipoGestionId);

        this.listGestores = result.list;
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    },
    async loadTiposGestion(){
      this.loading = true;
      try{
        var result = await http.get('tiposGestion');
        this.listTiposGestion = result.list;
        this.asignacionCommand.tipoGestionId = this.listTiposGestion[0].id;
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    },
    async selectMotivo(){

      let index = document.getElementById('motivo').selectedIndex

      this.asignacionCommand.motivo = this.motivoAsignacion[index].nombre;

    },
    async loadTareas(){
      this.loading = true;
      try{
        var result = await http.get('gestion/listtareasgestion');        

        this.listTareas = result.list;
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    },
    async loadSucursales(){
      this.loading = true;
      try{
        var result = await http.get('sucursales/list/porusuario?usuarioId='+this.user.id);

        this.sucursales = result.list;

        this.sucursales.unshift({id:0,nombre:'(Todas)'});
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    },
    async loadTiposCanalVenta() {
        this.loading = true
        try {
            var result = await http.get('tiposcanalventa');
            this.tiposCanalVenta = result.list;
            this.tiposCanalVenta.unshift({id:0,descripcion:'(Todos)'});
        } catch (error) {
            // Error
            Vue.$log.error(error);
        }
        this.loading = false
    },
    async getItems() {
      Vue.$log.debug(this.filtro)

      if(!this.validarFiltros()) return;
      
      this.loading = true
      this.$validator.reset()
      
      if(!this.filtrarPorCuotaEspecifica)
        this.filtro.soloCuotaEspecifica = 0;

      if(!this.filtrarPorUltimasCuotas)
        this.filtro.soloUltimasCuotas = 0;

      let filter = this.filtro;

      let idCanalesVenta = filter.canalVentaId.toString();
      
      //Si se eligió TODOS ( y no tiene acceso a todos los canales) armo un string con todos los canales de venta habilitados para el usuario.
      if(filter.canalVentaId === 0 )
      {
        if( !this.$store.state.user.accesoTodosCanalesVenta){
          for(var i = 1; i< this.canalesVenta.length;i++ )
          {
            if(i === 1)
            idCanalesVenta = this.canalesVenta[i].id;
            else
            idCanalesVenta += "," + this.canalesVenta[i].id;
          }
        }
        else{
          idCanalesVenta = "0";
        }
      }

      const filtrarVectorAtraso = filter.radioFiltroMora == 'FiltrarVectorAtraso';
      const filtrarInicioMora = !filtrarVectorAtraso;

      if(filter.asignadoA == '(Todos)')
        filter.asignadoA = '';

      try {
        var result = await http.get('gestion/getcasosparaasignacion?empresaId=' + filter.empresaId + '&sucursalId=' + filter.sucursalId + '&canalesVenta=' + idCanalesVenta + '&tipoCanalVentaId=' + filter.tipoCanalVentaId
                      + '&productoId=' + filter.productoId + '&planes=' + filter.planes
                      + '&filtrarVectorAtraso='+filtrarVectorAtraso+ '&vectorAtrasoDesde='+filter.vectorAtrasoDesde + '&vectorAtrasoHasta=' + filter.vectorAtrasoHasta 
                      + '&filtrarInicioMora='+filtrarInicioMora + '&inicioMoraDesde=' + filter.inicioMoraDesde  + '&inicioMoraHasta=' + filter.inicioMoraHasta
                      + '&filtrarFechaUltimoPago='+filter.filtrarFechaUltimoPago + '&fechaUltimoPagoHasta=' + filter.fechaUltimoPagoHasta
                      + '&filtrarDeuda='+filter.filtrarDeuda + '&deudaDesde=' + filter.deudaDesde + '&deudaHasta=' + filter.deudaHasta
                      + '&excluirCasosConAcuerdosAlDia=' + filter.excluirAcuerdosAlDia + '&excluirPromesasPagoNoVencidas=' + filter.excluirPromesasPagoNoVencidas
                      + '&situacionAsignacion='+filter.situacionAsignacion+'&fechaAsignacionDesde='+filter.fechaAsignacionDesde + '&fechaAsignacionHasta=' + filter.fechaAsignacionHasta 
                      + '&asignadoA=' + filter.asignadoA + '&soloCuotaEspecifica=' + filter.soloCuotaEspecifica + '&soloUltimasCuotas=' + filter.soloUltimasCuotas +'&categoriaPlan=' +filter.categoriaPlanes);

        Vue.$log.debug(result);
        
        this.records = result.list;
        this.totalItems = result.totalCount

        this.selectedCasos = [];
        this.currentTab = 1;
        
      } catch (error) {
        // Error
        this.alertError(error)
      }
      this.loading = false
    },
    async procesarCasos()
    {
      if(!this.validarComandoAsignacion()) return;

      this.loading = true;
      this.asignacionCommand.empresaId = this.filtro.empresaId;
      this.asignacionCommand.personasId = this.selectedCasos.map(c => c.personaId);
      
      if(this.asignacionCommand.modoAsignacion === 'AsignarPrimeros')
      {
        //agarro los primeros x del array
        if(this.asignacionCommand.asignarPrimeros <= this.asignacionCommand.personasId.length)
        {
          this.asignacionCommand.personasId.length = this.asignacionCommand.asignarPrimeros;
        }
      }
      
      if(this.asignacionCommand.modoAsignacion != 'Desasignar')
      {
        //seleccionMultipleGestores depende de si está marcado asignar prorrateado.
        //si está marcado se pone en true y manda el array de gestoresId directo, si no es un valor solo y lo paso a un array para que lo agarre el server
        if(!this.seleccionMultipleGestores)
          this.asignacionCommand.gestoresId = [this.asignacionCommand.gestoresId];
      }

      try{
        var result = await http.post('gestion/asignargestionesmora', JSON.stringify( {casos:  this.asignacionCommand} ) );
        
        if(confirm('Se ha realizado la asignación. ¿Desea quitar los casos asignados de la lista?'))
        {
          const casosAsignadosId = result.casosAsignadosId;
          //Hago esto para sacar a los selectedCasos de la lista, si no quedan marcados.
          let selectedCasosId = this.selectedCasos.map(c => c.personaId);
          for(let i = 0; i<casosAsignadosId.length;i++ )
          {
            var index = this.selectedCasos.map(c => c.personaId).indexOf(casosAsignadosId[i]);
            if (index > -1) {
              this.selectedCasos.splice(index, 1);
            }

            for (let j = this.records.length - 1; j >= 0; j--)
            { 
              if(this.records[j].personaId === casosAsignadosId[i])
              {
                this.records.splice(j,1);
              }
            }
          }
        }
        
        this.alertSuccess('Los cambios han sido guardados.');
      } 
      catch(error){
        Vue.$log.error(error);
        // Error
        this.alertError(error)
      }            

      this.loading=false;
    },
    validarFiltros()
    {
      if(this.filtro.radioFiltroMora == 'FiltrarVectorAtraso')
      {
        if(isNaN(this.filtro.vectorAtrasoDesde) || isNaN(this.filtro.vectorAtrasoHasta))
        {
          this.alertWarning('El valor del filtro de Vector Atraso es incorrecto.');
          return false;
        }
      }

      return true;
    },
    validarComandoAsignacion()
    {
        if(!this.selectedCasos.length > 0)
        {
          this.alertWarning('Debe elegir algún caso para asignar.');
          return false;
        }
        if(this.asignacionCommand.modoAsignacion != 'Desasignar')
        {
          if(!(this.asignacionCommand.gestoresId.length > 0))
          {
            this.alertWarning('Debe elegir un gestor de la lista.');
            return false;
          }

          if(!this.asignacionCommand.tareaId || this.asignacionCommand.tareaId === 0)
          {
            this.alertWarning('Debe elegir la tarea a asignar.');
            return false;
          }
        }
        
        if(this.asignacionCommand.modoAsignacion == 'AsignarPrimeros')
        {
          if(isNaN(this.asignacionCommand.asignarPrimeros))
          {
            this.alertWarning('Debe ingresar un valor válido en Asignar Primeros.');
            return false;
          }
          else if(this.selectedCasos.length < this.asignacionCommand.asignarPrimeros)
          {
            this.alertWarning('El valor de Asignar Primeros no puede ser mayor a la cantidad de casos marcados.');
            return false;
          }
        }  
        return true;
    },
    async traerListaOperacionesDeExcel(){

      if(!this.archivoFiltroOperaciones) return;
      if(!this.archivoFiltroOperaciones.name.includes('.xls'))
      {
        this.archivoFiltroOperaciones = [];
        this.alertWarning('Debe elegir un archivo Excel.');
        return;
      }

      this.loading = true;
      let formData = new FormData();  

      formData.append('archivo',this.archivoFiltroOperaciones);

      try{
        var listaOps = await http.post('archivosDebito/excelAFiltroOperaciones', formData);
        this.operacionesFiltro = listaOps;
      } catch (error) {
          // Error
          this.alertError(error)
      }
      
      this.loading = false;

    },
    async importarExcel(){
      this.loading = true;

      try {
        var result = await http.get('gestion/getcasosparaasignacionagestorporlistacreditos?empresaId='+this.filtro.empresaId + '&filtroId='+ this.operacionesFiltro.id);
        
        this.records = result.list;
        this.totalItems = result.totalCount

        //esto cuenta los personaid que trajo, para que cuente los duplicados al hacer la diferencia
        let personasEncontradas = new Set(this.records.map(c => c.personaId));

        if(personasEncontradas.size != this.operacionesFiltro.cantidad){
          var diff = this.operacionesFiltro.cantidad - personasEncontradas.size;
          this.alertWarning('Hay ' + diff + ' casos de diferencia entre los del archivo y los encontrados en condiciones de asignar.')
        }

        this.selectedCasos = [];
        this.currentTab = 1;
        
      } catch (error) {
        // Error
        this.alertError(error)
      }
      this.loading = false

    },
    async asignarMasivoDesdeExcel(){

      if(!this.archivoAsignacionDirecta) return;
      if(!this.archivoAsignacionDirecta.name.includes('.xls'))
      {
        this.archivoAsignacionDirecta = [];
        this.alertWarning('Debe elegir un archivo Excel.');
        return;
      }

      if(!this.empresaAsignacionDirectaId || this.empresaAsignacionDirectaId == 0)
      {
        this.alertWarning('Debe elegir la empresa para la asignación masiva desde excel.');
        return;
      }

      this.loading = true;
      let formData = new FormData();  

      formData.append('excelFile',this.archivoAsignacionDirecta);
      formData.append('empresaId',this.empresaAsignacionDirectaId);

      try{
        var res = await http.post('gestion/asignarmasivoexcel', formData);

        Vue.$log.debug(res);

        this.alertSuccess('Se asignaron ' + res.casosAsignadosId.length + ' casos con éxito.');

        this.archivoAsignacionDirecta = [];
      } catch (error) {
          // Error
          this.alertError(error)
      }
      
      this.loading = false;

    },
    changeTab()
    {
      this.currentTab = 1;
    },
    async verLegajo(item){
      this.selectedPersonaId = item.personaId;
      this.showLegajoPersona = true;
    },
    async verCreditos(item){
      this.selectedPersonaId = item.personaId;
      
      var params = {
          width:900,
          visible: true,
          personaId: item.personaId
      };

      this.setActiveTask({task:'app-lista-creditos', props: params})
    },
    selectAllChanged(toggle){
      this.selectedCasos = []
      if(toggle){
        for (let index = 0; index < this.records.length; index++) {
          const element = this.records[index];
          
          this.selectedCasos.push(element)
        }
      }
    }
  }
}
</script>
